import React from 'react';
import dollars from '../../dollar-format';
import {renderPrintFooter} from "../../utils";
import {executeQuery} from "../../requests/executeQuery";
import {STRIVE_INVENTORY_V2} from '../../consts/queries';

export default class Inventory extends React.Component {
	constructor(props) {
	    super(props);
		this.state = {
            rows: {
                STNL: {},
                MT: {},
                Other: {},
                Total: {}
            },
            isPrint: false,
            printBackground: '',
		};

        this.beforePrint = this.beforePrint.bind(this);
        this.afterPrint = this.afterPrint.bind(this);
	}

    static buildRowData(data, type) {
        const totalProperties = parseInt(data.TOTAL_PROPERTIES);
        const totalFee = parseFloat(data.TOTAL_FEE);
        const aveGrossFee = totalFee / totalProperties;
        return {
            type: type,
            properties: totalProperties,
            totalPrice: parseFloat(data.TOTAL_PRICE),
            totalFee: totalFee,
            aveGrossFee: aveGrossFee,
            aveNetFee: aveGrossFee / 2,
        };
    }

    static buildTotalData(rows) {
	    const dataToSum = {...rows};
        delete dataToSum.Total;

        Object.keys(dataToSum).forEach(key => {
            if (!dataToSum[key].properties) delete dataToSum[key];
        });

        const properties =  Object.keys(dataToSum).reduce((previous, key) => previous + dataToSum[key].properties, 0);
	    const totalPrice = Object.keys(dataToSum).reduce((previous, key) => previous + dataToSum[key].totalPrice, 0);
	    const totalFee = Object.keys(dataToSum).reduce((previous, key) => previous + dataToSum[key].totalFee, 0);
	    const aveGrossFee = totalFee / properties;

        return {
            type: 'Total',
            properties: properties,
            totalPrice: totalPrice,
            totalFee: totalFee,
            aveGrossFee: aveGrossFee,
            aveNetFee: aveGrossFee / 2,
        };
    }

	fetch() {
        Promise.all([
            executeQuery({queryName: STRIVE_INVENTORY_V2, params: {TYPE: 'STNL'}}),
            executeQuery({queryName: STRIVE_INVENTORY_V2, params: {TYPE: 'MT'}}),
            executeQuery({queryName: STRIVE_INVENTORY_V2, params: {TYPE: 'Other'}}),
        ]).then(res => {
            if (res && res[0] && res[0].success && Array.isArray(res[0].data) && res[0].data.length &&
                res[1] && res[1].success && Array.isArray(res[1].data) && res[1].data.length &&
                res[2] && res[2].success && Array.isArray(res[2].data) && res[2].data.length) {
                const rows = {...this.state.rows};
                const stnlData = res[0].data[0];
                const mtData = res[1].data[0];
                const otherData = res[2].data[0];
                rows.STNL = Inventory.buildRowData(stnlData, 'STNL');
                rows.MT = Inventory.buildRowData(mtData, 'MT');
                rows.Other = Inventory.buildRowData(otherData, 'Other');
                rows.Total = Inventory.buildTotalData(rows);
                this.setState({rows});
            }
        });
	}

	componentDidMount() {
        this.setState({printBackground: `url('${arc.path.media+'Transaction_Background.png'}')`}, this.fetch);
        window.onbeforeprint = this.beforePrint;
        window.onafterprint = this.afterPrint;
	}

    beforePrint() {
        this.setState({isPrint: true});
    }

    afterPrint() {
        this.setState({isPrint: false});
    }

	render() {
        const {rows, isPrint, printBackground} = this.state;
        const d = new Date();
		const date = d.getMonth()+1+'/'+d.getDate()+'/'+d.getFullYear();

		return (
            <div className='Inventory'>
                <div className='print-container' style={{backgroundImage: isPrint && printBackground}}>
                    <div className="Inventory_head_left">
                        <h3 className='Inventory_h3'>STRIVE Inventory</h3>
                        <h4 className='Inventory_h4'>{date}</h4>
                    </div>
                    <table className='table'>
                        <thead>
                        <tr>
                            <th className="Inventory_th">Type</th>
                            <th className="Inventory_th"># of Active Properties</th>
                            <th className="Inventory_th">Total Price</th>
                            <th className="Inventory_th">Total Fee</th>
                            <th className="Inventory_th">Ave Gross Fee</th>
                            <th className="Inventory_th">Ave Net Fee</th>
                        </tr>
                        </thead>
                        <tbody>
                        {
                            Object.keys(rows).map((key, index) => {
                                return (
                                    <tr key={key} className={index === Object.keys(rows).length - 2 ? "Inventory_total" : ''}>
                                        <td className="Inventory_td">{rows[key].type}</td>
                                        <td className="Inventory_column_numeric">{rows[key].properties}</td>
                                        <td className="Inventory_column_numeric">{rows[key].totalPrice ? dollars(rows[key].totalPrice) : '$0'}</td>
                                        <td className="Inventory_column_numeric">{rows[key].totalFee ? dollars(rows[key].totalFee, true) : '$0'}</td>
                                        <td className="Inventory_column_numeric">{rows[key].aveGrossFee ? dollars(rows[key].aveGrossFee, true) : '$0'}</td>
                                        <td className="Inventory_column_numeric">{rows[key].aveNetFee ? dollars(rows[key].aveNetFee, true) : '$0'}</td>
                                    </tr>
                                );
                            })
                        }
                        </tbody>
                    </table>
                    {renderPrintFooter(isPrint)}
                </div>
                <div className='preload-print-background' style={{backgroundImage: printBackground}}/>
            </div>
		);
	}
}
